import React, { useState } from "react";
import PrivateApi from "../../services/PrivateApiService";
import { Button, Modal, Spinner } from "react-bootstrap";

/**
 * 
 * used in: ElvDetailPage
 * 
 * @param {elv} props object elv
 * @param {show} props bool to show/hide modal
 * @param {setShow} props setter bool
 */
const ElvLeerstandModal = (props) => {

    const API = new PrivateApi();
    const [leerstandModalBody, setLeerstandModalBody] = useState("default");

     // function for Leerstand abmeldung
     const leerstandAbmeldungHanlder = () => {
        setLeerstandModalBody("waiting");
        var anlagen = { selectedAnlagen: [props.elv.x_anlage_id.id], date: new Date().toISOString().split('T')[0], no_qr_code: true };
        API.hw_AnlagenSetLeerstand(anlagen)
            .then(() => {
                setLeerstandModalBody("success");
            })
            .catch(() => {
                setLeerstandModalBody("error");
            })
    }

    return (
        <Modal show={props.show} onHide={() => props.setShow(false)}>
            <Modal.Header closeButton>
                <Modal.Title>Leerstand abmelden</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {
                    leerstandModalBody === "default" ?
                        <p>Sind Sie sicher, dass Sie diesen Leerstand abmelden wollen?</p>:
                    leerstandModalBody === "waiting" ?
                        <div className="text-center">
                            <p>Daten werden übermittelt...</p>
                            <Spinner animation="grow" className="text-energo" /> &nbsp;
                            <Spinner animation="grow" className="text-energo" /> &nbsp;
                            <Spinner animation="grow" className="text-energo" />
                        </div>:
                    leerstandModalBody === 'success' ?
                        <p className="text-energo text-center">Anlage erfogreich von Leerstand abgemeldet</p>:
                    leerstandModalBody === 'error' ?
                        <p className="text-danger">Fehler passiert bei übermitteln von Daten, bitte versuchen Sie es später nochmal</p>:
                    null
                }
            </Modal.Body>
            <Modal.Footer hidden={leerstandModalBody !== "default"}>
                {
                    leerstandModalBody === "default" ?
                        <div>
                            <Button variant="danger" onClick={() => { setLeerstandModalBody('default'); props.setShow(false) }}>Nein</Button>
                            &nbsp;
                            <Button className="btn-energo" onClick={() => leerstandAbmeldungHanlder()}>Ja, ich bin sicher</Button>
                        </div>:
                    leerstandModalBody === "error" ?
                        <Button variant="danger" onClick={() => setLeerstandModalBody('default')}>Zurück</Button>:
                    leerstandModalBody === "success" ?
                        <Button className="btn-energo" onClick={() => props.setShow(false)}>Schließen</Button>:
                    null
                }
            </Modal.Footer>
        </Modal>
    )
}

export default ElvLeerstandModal;